import { create } from 'zustand'
import type { GpuEffect } from '@/types/effects'
import { cloneGpuEffect } from '@/features/effects/utils/color-grade'

export interface GradeClipboardEntry {
  effect: GpuEffect
  enabled: boolean
}

interface GradeClipboardState {
  grade: GradeClipboardEntry[] | null
}

interface GradeClipboardActions {
  setGrade: (entries: GradeClipboardEntry[]) => void
  clearGrade: () => void
  hasGrade: () => boolean
}

export const useGradeClipboardStore = create<GradeClipboardState & GradeClipboardActions>(
  (set, get) => ({
    grade: null,

    setGrade: (entries) =>
      set({
        grade: entries.map((entry) => ({
          effect: cloneGpuEffect(entry.effect),
          enabled: entry.enabled,
        })),
      }),

    clearGrade: () => set({ grade: null }),

    hasGrade: () => {
      const grade = get().grade
      return Array.isArray(grade) && grade.length > 0
    },
  }),
)
